import { HttpClient } from '@angular/common/http';
import { makeStateKey, TransferState } from '@angular/core';
import { Observable, of } from 'rxjs';

import { TranslateLoader } from '@ngx-translate/core';

export class TranslateBrowserLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private transferState: TransferState,
    private basePath = 'opts'
  ) {}

  getTranslation(lang: string): Observable<any> {
    const key = makeStateKey(`translation-${lang}`);

    if (this.transferState.hasKey(key)) {
      const cached = this.transferState.get(key, null);

      this.transferState.remove(key); 

      return of(cached);
    }

    return this.http.get(`${this.basePath}/${lang}/translations/ang.json`);
  }
}
